import { RewardStarIcon } from './RewardStarIcon'
import { LABELS } from '../../lib/labels'

interface RewardPointsProps {
  points?: number | null
}

const WRAPPER_CLASSES = 'flex justify-center items-center min-h-[25px]'

/**
 * RewardPoints - Star icon with bonus points text
 *
 * Renders empty placeholder div when no points (maintains grid row height).
 * Matches CardItem.tsx reward_points display.
 */
export function RewardPoints({ points }: RewardPointsProps) {
  if (!points || points <= 0) {
    return <div className={WRAPPER_CLASSES} />
  }

  return (
    <div className={WRAPPER_CLASSES}>
      <div className="flex items-center justify-start gap-2">
        <RewardStarIcon className="w-5 h-5 text-custom-green" />
        <span className="text-text-color font-main-font text-sm font-bold">
          {points} {LABELS.REWARD_POINTS_SUFFIX}
        </span>
      </div>
    </div>
  )
}
